export default {
  /* eslint-disable no-param-reassign */
  setData(state, payload) {
    state.items = payload.items || [];
    state.pagination = payload.pagination || state.pagination;
    state.filters = payload.filters || state.filters;
  },
};
